// Core
import QS from "qs";
import { AxiosRequestConfig } from "axios";
import { http } from "@/network/http-provider";

// Definitions
import type { SearchType } from "./types";
import { HttpRequestParams } from "@/types/http";

// Utils
import { historyStorageName, searchKeys } from "./apiKeys";

export const searchApi = Object.freeze({
  fetchSearch: (payload: HttpRequestParams<void>) => {
    const { params } = payload;
    const config = {
      params,
      paramsSerializer: (p: AxiosRequestConfig): string =>
        QS.stringify(p, { encode: true, arrayFormat: "indices" }),
    };
    return http.get<SearchType>(searchKeys.providers, config);
  },
});
export const searchHistory = Object.freeze({
  setNewValue: (value: string) => {
    if (value.length == 0) return;
    const localValue = localStorage.getItem(historyStorageName) || "[]";
    const parceLocalValue = JSON.parse(localValue) as string[];
    localStorage.setItem(
      historyStorageName,
      JSON.stringify([value, ...parceLocalValue.filter((_value) => _value !== value)]),
    );
  },
  getHistory: () => {
    const localValue = localStorage.getItem(historyStorageName) || "[]";
    return JSON.parse(localValue) as string[];
  },
  deleteValue: (value: string) => {
    const localValue = localStorage.getItem(historyStorageName) || "[]";
    const parceLocalValue = JSON.parse(localValue) as string[];
    const newArray = parceLocalValue.filter((_value) => _value !== value);
    localStorage.setItem(historyStorageName, JSON.stringify(newArray));
    return newArray;
  },
});
